import React from 'react';

interface PersonalIconProps {
	className?: string;
}

export const PersonalIcon: React.FC<PersonalIconProps> = ({ className }) => (
	<svg 
		width="82" 
		height="82" 
		viewBox="0 0 27 28" 
		fill="none" 
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path 
			d="M13.5 10.3555C16.2615 10.3555 18.5 8.10982 18.5 5.36005C18.5 2.61028 16.2615 0.355469 13.5 0.355469C10.7385 0.355469 8.5 2.60111 8.5 5.35089C8.5 8.10066 10.7477 10.3555 13.5 10.3555ZM13.5 2.43613C15.1147 2.43613 16.4266 3.74685 16.4266 5.36005C16.4266 6.97325 15.1147 8.28397 13.5 8.28397C11.8853 8.28397 10.5734 6.97325 10.5734 5.36005C10.5734 3.74685 11.8853 2.43613 13.5 2.43613Z" 
			fill="currentColor"
		/>
		<path 
			d="M19.1054 12.3555H7.88507C3.81186 12.3555 0.5 15.7189 0.5 19.8555C0.5 23.9921 3.81186 27.3555 7.88507 27.3555H19.1149C23.1881 27.3555 26.5 23.9921 26.5 19.8555C26.5 15.7189 23.1881 12.3555 19.1149 12.3555H19.1054ZM19.1054 25.1615H7.88507C5.00146 25.1615 2.66032 22.7839 2.66032 19.8555C2.66032 16.927 5.00146 14.5494 7.88507 14.5494H19.1149C21.9985 14.5494 24.3397 16.927 24.3397 19.8555C24.3397 22.7839 21.9985 25.1615 19.1149 25.1615H19.1054Z" 
			fill="currentColor"
		/>
	</svg>
);